
namespace RedBullMOBILE360.SMSCodes {

    @Serenity.Decorators.registerClass()
    export class SubscriptionCodesDialog extends Serenity.EntityDialog<SubscriptionCodesRow, any> {
        protected getFormKey() { return SubscriptionCodesForm.formKey; }
        protected getIdProperty() { return SubscriptionCodesRow.idProperty; }
        protected getLocalTextPrefix() { return SubscriptionCodesRow.localTextPrefix; }
        protected getNameProperty() { return SubscriptionCodesRow.nameProperty; }
        protected getService() { return SubscriptionCodesService.baseUrl; }
        protected getDeletePermission() { return SubscriptionCodesRow.deletePermission; }
        protected getInsertPermission() { return SubscriptionCodesRow.insertPermission; }
        protected getUpdatePermission() { return SubscriptionCodesRow.updatePermission; }

        protected form = new SubscriptionCodesForm(this.idPrefix);

    }
}